var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "10" } },
            [
              _c("v-file-input", {
                ref: "fileSelector",
                attrs: {
                  dense: "",
                  type: "file",
                  accept: "video/*",
                  showSize: false,
                  placeholder: _vm.inputPlaceholder
                },
                on: { "click:clear": _vm.onFileSelectorClear },
                model: {
                  value: _vm.file,
                  callback: function($$v) {
                    _vm.file = $$v
                  },
                  expression: "file"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    icon: "",
                    disabled: !_vm.isPreviewAvailable,
                    color: "white"
                  },
                  on: { click: _vm.previewVideo }
                },
                [_c("v-icon", [_vm._v("mdi-video")])],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.filePreview
        ? _c("popupDialog", { attrs: { dialogModel: _vm.filePreview } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }